<template>
  <div class="toast-container position-fixed bottom-0 end-0 p-3">
    <div :id="'liveToast-' + key" class="toast" role="alert" aria-live="assertive" aria-atomic="true" ref="toasts" data-bs-delay="20000" v-for="(error, key) in props.store.errors">
      <div class="toast-header">
        <span class="icon icon-alert me-2"></span>
        <strong class="me-auto">{{ toastTitle }}</strong>
        <button type="button" class="btn btn-no-styling p-0" data-bs-dismiss="toast" aria-label="Close">
          <span class="icon icon-close"></span>
        </button>
      </div>
      <div class="toast-body">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// @ts-ignore
import Toast from 'bootstrap/js/dist/toast';
// @ts-ignore
import { defineProps, onMounted, ref, watch } from 'vue';

const toasts = ref(null);

const props = defineProps<{
  store: object,
  toastTitle: string,
}>();

onMounted( async () => {
  if(toasts.value){
    toasts.value.map(async toast => {
      if (props.store.errors.length > 0) {
        await showToast(toast);
      }
    });
  }
})

async function showToast(toast){
  await Toast.getOrCreateInstance(toast).show();
}

watch(toasts, async (newValue, oldValue) => {
  toasts.value.map(async(toast) => {
    await showToast(toast);
  });
}, {deep: true});
</script>